import axios from '@/libs/http'

/**
 * 申请续单
 */
export const addOrderContinuedApply = (orderId, message,fileList) => {
  let data = new URLSearchParams()
  data.append("orderId", orderId)
  data.append("message", message)
  if(fileList){
    data.append('fileList', fileList)
  }
  return axios.request({
    url: '/s/c/order/continuedApply/apply',
    data,
    method: 'post'
  })
}


